import { Chip } from '@material-ui/core'
import React from 'react'

function ValueChip({ value, isPercent }) {
  const formatValue = (val) => {
    if (val === null || val === undefined) return 'N/A'
    if (isPercent) {
      return `${val}%`
    }
    return `${parseFloat(val).toFixed(2)} €`
  }

  return <Chip style={{ borderRadius: 0 }} label={formatValue(value)} />
}
export default ValueChip
